<div class="page-content container">
  <div class="page-header">
    <h1>
      {{ translationManager.getTranslation('Метод оцењивања понуда') }}
    </h1>
  </div>
  <div class="page-data shadow-sm">
    <div class="app-table-panel" app-table>
      <div class="app-table">
        <table class="table table-striped text-dark-m1">
          <thead>
            <tr class="bgc-primary-tp2 text-white">
              <th>
                {{ translationManager.getTranslation('Област оцењивања') }}
              </th>
              <th>
                {{ translationManager.getTranslation('Опис') }}
              </th>
<!--              <th>-->
<!--                {{ translationManager.getTranslation('Бодови') }}-->
<!--              </th>-->
<!--              <th style="width: 100px" class="right">-->
<!--                {{ translationManager.getTranslation('Акције') }}-->
<!--              </th>-->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items">
              <td>{{ translationManager.getTranslation('AssessmentArea-Name#' + item.assessmentAreaId) }}</td>
              <td>{{ item.description }}</td>
<!--              <td>{{ item.points }}</td>-->
<!--              <td class="right" *ngIf="state === viewState.Create || state === viewState.Edit"  style="width:5%">-->

<!--                <div class="table-actions" >-->
<!--                  <a *ngIf="(requestStatus == requestStatusUniqueIdentifier.inProgress || requestStatus == requestStatusUniqueIdentifier.changesBack)-->
<!--                      && auth.isAuthorized('D5CBBC38-F83A-47A2-A353-C74D4E7A6441')" href="javascript:;"-->
<!--                    (click)="showDeleteModalFor(item.id)" class="red"-->
<!--                    [title]="translationManager.getTranslation('Брисање')">-->
<!--                    <i class="far fa-trash-alt"></i>-->
<!--                  </a>-->
<!--                </div>-->

<!--              </td>-->
            </tr>

<!--            <tr style="background-color: #253965">-->
<!--              <td></td>-->
<!--              <td style="color: white;font-weight: bold;">{{translationManager.getTranslation('Укупно')}}</td>-->
<!--              &lt;!&ndash;<td style="color: white;font-weight: bold;"> {{ pointsSum }}</td> &ndash;&gt;-->
<!--&lt;!&ndash;              <td *ngIf="state === viewState.Create || state === viewState.Edit"></td>&ndash;&gt;-->
<!--            </tr>-->

            <div *ngIf="state === viewState.Edit">
            </div>

          </tbody>
        </table>

        <div *ngIf="state === viewState.Edit">
          <opn-offer-evaluation-method-elements #elements [state]="state"></opn-offer-evaluation-method-elements>
        </div>

        <div class="no-content" *ngIf="!items || items.length == 0">
          <span>{{ translationManager.getTranslation('Без података') }}</span>
        </div>
      </div>
<!--      <div class="form-element-buttons">-->
<!--        <button class="btn btn-warning fl" (click)="navigateToList()">-->
<!--          <i class="fa fa-arrow-left mr-2"></i>{{ translationManager.getTranslation('Назад') }}</button>-->
<!--        <button class="btn btn-success fr" (click)="submit()" *ngIf="state === viewState.Edit">-->
<!--          <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Сачувај') }}</button>-->
<!--      </div>-->
    </div>
  </div>

  <app-modal [show]="showDeleteModal" (onHide)="closeDeleteModal()"
    [title]="translationManager.getTranslation('Брисање оцене')">
    <div class="app-modal-content">
      <label>{{ translationManager.getTranslation('Да ли сте сигурни да желите да обришете оцену?') }}</label>
    </div>
    <div class="app-modal-actions">
      <button class="btn btn-success" (click)="delete()">
        <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
      <button (click)="closeDeleteModal()" class="btn btn-warning">
        <i class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
    </div>
  </app-modal>
